import {reactive} from "vue";

export const phoneMask = reactive({
    mask: "+7(###)-###-##-##",
    eager: true,
    preProcess: (value) => {
        if (value.startsWith('+7')) return value.slice(2);
        if (value.startsWith('8') || value.startsWith('7')) return value.slice(1);
        return value;
    }
});

export const passportCodeMask = reactive({
    mask: "###-###",
    eager: true
});

export const passportSeriesNumberMask = reactive({
    mask: "## ## ######",
    eager: true
});

export const dateMask = reactive({
    mask: "##.##.####",
    eager: true
});

/** @param {string} value */
export const isPhoneInput = (value) => /^[+\d]/.test(value);

/** @param {string} value */
export const unmaskPhone = (value) => String(value ?? '').replace(/\D/g, '');
